module.exports = __webpack_public_path__ + "images/landing-page-mobile-bg.jpg";